import addFormats from 'ajv-formats';
import AJV from './module';
import { AJV_EXTENSION_PROPERTY_PATH, AJV_EXTENSION_REF_SCHEMA, X_OBJECT_TYPE } from '../globals';
import { ISchemaAJV } from './types';

/**
 * Instantiate AJV with defaults
 */
export function initAJV({
    prune_additional_properties,
}: {
    prune_additional_properties: boolean;
}): ISchemaAJV {
    const ajv = new AJV({
        strict: true,
        allErrors: true,

        //  Data modification
        useDefaults: true,
        removeAdditional: prune_additional_properties,
    });

    //  Add string formats from `ajv-formats` package (https://www.npmjs.com/package/ajv-formats)
    addFormats(ajv);

    ajv.addFormat(
        'email',
        /^[a-z\u00C0-\u024F\u1E00-\u1EFF0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z\u00C0-\u024F\u1E00-\u1EFF0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
    );

    //  Add AJV schema keywords
    ajv.addKeyword({
        keyword: AJV_EXTENSION_REF_SCHEMA,
        modifying: false,
    })
        .addKeyword({
            keyword: AJV_EXTENSION_PROPERTY_PATH,
            modifying: false,
        })
        .addKeyword({
            keyword: X_OBJECT_TYPE,
            modifying: false,
        });

    return { ajv, is_instantiated: true };
}
